<template>
  <div class="yxtbiz-skill-viewer">
    <yxt-radio-group
      v-model="type"
      class="mb24 float__right"
      type="tab-radio"
      size="small"
    >
      <yxt-radio-button label="radar">
        {{ $t('pc_gwnl_web_radarShow') }}
      </yxt-radio-button>
      <yxt-radio-button label="table">
        {{ $t('pc_gwnl_training_listShow') }}
      </yxt-radio-button>
    </yxt-radio-group>
    <div class="flex width100">
      <template v-if="type === 'radar'">
        <div
          v-for="data in skills"
          :key="data.id"
          class="flex-column-center"
          :style="{ width: `${skills.length ? 100 / skills.length : 100}%` }"
        >
          <template v-if="slotRador">
            <slot
              name="radar"
              :data="data[classifyProps]"
            />
          </template>
          <yxtbiz-polestar-radar
            v-else
            class="width100"
            :datas="data[classifyProps]"
            :fields="legends"
            :fields-map="fieldsMap"
            :child-key="childKey"
            :options="options"
            :checkbox="checkbox"
            :checkbox-style="{ marginTop: '24px' }"
            checkbox-color-type="marker"
            :label-style="labelStyle"
            :radius="radius"
            :axis="axis"
            :label="label"
            :virtual-line="!showSkillLevel"
            :value-map="enableExcellentLevel ? excellentShowLevelName : showLevelName"
            @labelClick="handleLabelClick"
          />
          <div
            :key="data.id"
            class="text-center font-size14 lh22 color-gray-10 mt24 font-weight-500"
          >
            {{ data.name }}
          </div>
        </div>
      </template>
      <template v-if="type === 'table'">
        <template v-if="slotTable">
          <slot
            class="flex-align-center flex-grow"
            name="table"
          />
        </template>
        <skill-tables
          v-else
          class="flex-column-center flex-grow"
          :skill-catalogs="skills"
          :enable-weight-switch="enableWeightSwitch"
          :enable-excellent-level="enableExcellentLevel"
          :is-show-skill-level="!!showSkillLevel"
          :classify-props="classifyProps"
          :child-key="childKey"
        />
      </template>
    </div>
  </div>
</template>

<script>
import skillTables from './skillTables';

export default {
  components: { skillTables },
  props: {
    /**
     * 分类字段
     */
    classifyProps: {
      type: String,
      default: 'skillModelClassifications'
    },
    skills: {
      type: Array,
      default: () => {
        return [];
      }
    },
    enableWeightSwitch: {
      type: Number,
      default: 0
    },
    enableExcellentLevel: {
      type: Number,
      default: 0
    },
    showSkillLevel: {
      type: [Boolean, Number],
      default: true
    },
    /**
     * 雷达图圆占比
     */
    radius: {
      type: Number,
      default: 0.8
    },
    label: {
      type: String,
      default: ''
    },
    /**
     * 坐标轴配置
     */
    axis: {
      type: Object,
      default: () => {
        return {
          labelLength: 8
        };
      }
    },
    /**
     * 合并g2的chart配置
     */
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 标记二级能力数组的字段名
    childKey: {
      type: String,
      default: 'jqSkillMaps'
    },
    /**
     * 字段映射关系
     */
    fieldsMap: {
      type: Object,
      default: () => {
        return {};
      }
    },
    slotRador: {
      type: Boolean,
      default: false
    },
    slotTable: {
      type: Boolean,
      default: false
    },
    labelStyle: {
      type: Object,
      default: () => {}
    },
    checkbox: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    legends: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      type: 'radar',
      chartFields: this.fields
    };
  },
  methods: {
    handleLabelClick() {
      this.$emit('labelClick', ...arguments);
    },
    showLevelName(items, isSubSkill) {
      const levelNameProp = 'standardLevelName';
      return isSubSkill
        ? items[levelNameProp]
        : items.flatMap((item) => {
          if (item.data.family === 2) {
            const tooltipContent =
                item.data[levelNameProp] || item.data.standLevelName;
            return {
              ...item,
              value: tooltipContent
            };
          } else {
            return item.data[this.childKey].map((subSkill) => {
              return {
                name: subSkill.name,
                value: subSkill[levelNameProp]
              };
            });
          }
        });
    },
    excellentShowLevelName(items, isSubSkill = false) {
      if (isSubSkill) {
        return this.getSkillName4show(items, ...this.getProps(items));
      } else {
        return items.map((item) => {
          return {
            ...item,
            value: this.getSkillName4show(item.data, ...this.getProps(item))
          };
        });
      }
    },
    getSkillName4show(items, levelNameProp, valueProp) {
      const value =
        items[valueProp] === undefined ? items.fieldsLevel : items[valueProp];
      const levelName = items[levelNameProp]
        ? items[levelNameProp].length > 5
          ? items[levelNameProp].slice(0, 5) + '...'
          : items[levelNameProp]
        : '';
      if (this.virtualLineStyle) {
        return '';
      }
      if (this.onEvalResult) {
        return items[levelNameProp] || value;
      }
      return levelName ? `${levelName}` : value;
    },
    getProps(items) {
      const matchedLegend = this.legends.find(
        (item) => item.name === items.fieldsType
      );
      return matchedLegend && matchedLegend.props ? [matchedLegend.props.hoverLevelProp, matchedLegend.props.hoverValueProp] : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-skill-viewer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .flex-column-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .flex-align-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex-grow {
    flex-grow: 1;
  }
}
</style>